import { Outlet, useLocation } from "react-router-dom";
import AuthPageNew from "./AuthPage";
import LoginPage from "./index";
import { ROUTES } from "../../constants/routes";

const AuthPageWrapper = () => {
  const location = useLocation();
  const isOldLayoutPage = 
    location.pathname === ROUTES.LOGIN + ROUTES.RESET_PASSWORD ||
    location.pathname === ROUTES.LOGIN + ROUTES.NEW_PASSWORD ||
    location.pathname === ROUTES.LOGIN + ROUTES.CHANGE_PASSWORD;

  if (isOldLayoutPage) {
    return <LoginPage><Outlet /></LoginPage>;
  }

  return <AuthPageNew><Outlet /></AuthPageNew>;
};

export default AuthPageWrapper;

